import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight, Eye, Users, ScanLine, Lock } from 'lucide-react';
import MainLayout from '../components/layout/MainLayout';
import { schrankApi, featureFlagsApi } from '../lib/api';
import { useAuthStore } from '../lib/store';
import { Skeleton } from '../components/ui/skeleton';
import '../components/schrank/schrank-workspace.css';

const sections = [
  { title: 'Ansicht', path: '/schrank/ansicht', key: 'schrank-ansicht', icon: Eye,
    description: 'Räume entdecken und Schrankbelegungen ansehen.', label: 'Zur Übersicht' },
  { title: 'Verwaltung', path: '/schrank/verwaltung', key: 'schrank-verwaltung', icon: Users,
    permission: 'can_manage_zuweisung', description: 'Schränke Personen und Abteilungen zuweisen.', label: 'Belegung verwalten' },
  { title: 'Raumplanung', path: '/schrank/raumverwaltung', key: 'schrank-raumverwaltung', icon: ScanLine,
    permission: 'can_edit_grundriss', description: 'Gebäude, Etagen und Räume gestalten.', label: 'Planung öffnen' },
];

export default function SchrankStartPage() {
  const user = useAuthStore(state => state.user);
  const [access, setAccess] = useState(null);
  const [failed, setFailed] = useState(false);
  useEffect(() => {
    let active = true;
    Promise.all([schrankApi.getMyPermissions(), featureFlagsApi.getActiveMenuKeys()])
      .then(([permissions, flags]) => { if (active) setAccess({ permissions: permissions.data, flags: flags.data || [] }); })
      .catch(() => { if (active) setFailed(true); });
    return () => { active = false; };
  }, []);
  const visible = access ? sections.filter(section =>
    (!section.permission || access.permissions[section.permission]) &&
    (user?.rolle === 'DEVELOPER' || access.flags.includes(section.key))
  ) : [];
  return <MainLayout><div className="schrank-workspace schrank-start" data-testid="schrank-start-page">
    <header className="schrank-start-header">
      <div className="schrank-eyebrow"><Lock size={16} /> Räume & Belegung</div>
      <h1>Schränke</h1><p>Wähle deinen Arbeitsbereich.</p>
    </header>
    {!access && !failed && <div className="schrank-entry-grid">{[0, 1, 2].map(i => <Skeleton key={i} className="h-64" />)}</div>}
    {failed && <p role="alert" className="schrank-empty">Die Bereiche konnten nicht geladen werden. Bitte lade die Seite erneut.</p>}
    {access && <nav aria-label="Schrankbereiche" className="schrank-entry-grid">
      {visible.map(({ title, path, icon: Icon, description, label }, index) =>
        <Link to={path} key={path} className="schrank-entry-card">
          <div className="schrank-entry-top"><Icon size={28} strokeWidth={1.5} /><span>0{index + 1}</span></div>
          <h2>{title}</h2><p>{description}</p>
          <div className="schrank-entry-link">{label}<ArrowUpRight size={20} /></div>
        </Link>)}
    </nav>}
    {access && !visible.length && <p className="schrank-empty">Für dich sind derzeit keine Schrankbereiche freigegeben.</p>}
  </div></MainLayout>;
}
